import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { NavBar, DataTables, TimeOut, BreadCumb } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import moment from 'moment';
import PendingCutDetailModal from '../../components/PendingCutDetailModal';
import { processPendingPayment } from '../../libs/utils/processPendingPayment';

let apiClient = ApiClient.getInstance();

// Estas claves deben coincidir con los campos devueltos por getPendingCutsByBranch.
const headersDataTable = [
    { key: "idSession", title: "ID Sesión", active: true },
    { key: "userName", title: "Usuario", active: true },
    { key: "role", title: "Rol", active: true },
    { key: "sucursal", title: "Sucursal", active: true },
    { key: "origin", title: "Origen", active: true },
    { key: "docDate", title: "Fecha de inicio", active: true },
    { key: "initSession", title: "Hora de inicio", active: true },
    { key: "sessionStatus", title: "Estado", active: true },
];

// Mantiene el selector de sucursal utilizable en pantallas angostas y sobre tabla/modales.
const sucursalSelectStyles = {
    control: (base) => ({ ...base, minWidth: 300, height: 40, borderColor: '#ced4da' }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
};

// Gestiona filtros, ciclo de búsqueda asíncrona y detalle del corte seleccionado.
class PendingCutsView extends Component {
    constructor(props) {
        super(props);
        const today = moment().format('YYYY-MM-DD');
        this.state = {
            // Lo usa NavBar; la consulta usa el filtro explícito de sucursal definido abajo.
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            branches: [],
            selectBranch: '',
            // La API devuelve una página de sesiones y sus contadores agregados.
            cuts: [],
            total: 0,
            gas: 0,
            comercio: 0,
            morePages: false,
            initialDate: today,
            finalDate: today,
            datesModified: true,
            userSearch: '',
            page: 1,
            // DataTables devuelve este objeto al navegar páginas consultadas en servidor.
            searchData: {
                selectBranch: '',
                initialDate: today,
                finalDate: today,
                datesModified: true,
                userSearch: '',
            },
            idSessionSelected: null,
            sessionInfo: null,
            selectedSessionIds: [],
            processingCuts: false,
            loading: false,
            // Remontar al iniciar una búsqueda limpia el estado interno de página/filtros de DataTables.
            tableVersion: 0,
            showExtendedRangeWarning: false,
            extendedRangeApproved: false,
        };
        // Un id creciente evita que una respuesta tardía de una solicitud cancelada afecte la vista.
        this.searchRequest = 0;
        this.searchController = null;
        this.isUnmounted = false;
    }

    // La búsqueda inicial usa hoy; las sucursales son auxiliares y su falla no la bloquea.
    componentDidMount = async () => {
        await this.GetBranches();
        this.SearchPendingCuts(1);
    };

    // Evita que una consulta en curso actualice Redux o este componente desmontado.
    componentWillUnmount = () => {
        this.isUnmounted = true;
        this.searchRequest += 1;
        if (this.searchController) this.searchController.abort();
    };

    // El catálogo de sucursales solo alimenta el selector opcional.
    GetBranches = async () => {
        try {
            const response = await apiClient.getBranches();
            if (response.status === SERVICE_RESPONSE.SUCCESS && !this.isUnmounted) {
                this.setState({ branches: response.data || [] });
            }
        } catch (error) {
            // La consulta de cortes sigue disponible aunque falle el catálogo de sucursales.
        }
    };

    // Conserva únicamente los filtros necesarios para los callbacks de paginación de DataTables.
    UpdateSearchData = () => {
        const { selectBranch, initialDate, finalDate, datesModified, userSearch } = this.state;
        return { selectBranch, initialDate, finalDate, datesModified, userSearch };
    };

    // Rechaza pronto un rango inválido y revoca una autorización previa de rango amplio.
    ChangeInitialDate = (event) => {
        const value = event.target.value;
        if (this.state.finalDate && value > this.state.finalDate) {
            return;
        }
        this.setState({
            initialDate: value,
            datesModified: true,
            extendedRangeApproved: false,
            showExtendedRangeWarning: false,
        });
    };

    // Aplica la misma validación cuando el usuario cambia la fecha final.
    ChangeFinalDate = (event) => {
        const value = event.target.value;
        if (this.state.initialDate && value < this.state.initialDate) {
            return;
        }
        this.setState({
            finalDate: value,
            datesModified: true,
            extendedRangeApproved: false,
            showExtendedRangeWarning: false,
        });
    };

    // Cambiar sucursal busca de inmediato y vuelve obsoleta la solicitud anterior.
    ChangeBranch = (selectedOption) => {
        this.searchRequest += 1;
        if (this.searchController) this.searchController.abort();
        this.setState({ selectBranch: selectedOption ? selectedOption.value : '' }, () => this.SearchPendingCuts(1));
    };

    // El texto se envía solo al buscar o al cambiar página/sucursal.
    ChangeUserToSearch = (event) => {
        this.setState({ userSearch: event.target.value });
    };

    // DataTables lo invoca antes de solicitar otra página al servidor.
    refreshSearch = (searchData) => {
        this.setState({
            searchData: { ...searchData }
        });
    };

    // Ejecuta la búsqueda en servidor; la paginación de DataTables aporta `search.PageNumber`.
    SearchPendingCuts = async (search = {}) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { selectBranch, initialDate, finalDate, userSearch, extendedRangeApproved } = this.state;

        // Una diferencia de 30 representa 31 días calendario inclusivos y no requiere confirmación.
        const isExtendedRange = moment(finalDate).diff(moment(initialDate), 'days') > 30;
        if (isExtendedRange && !extendedRangeApproved) {
            this.setState({ showExtendedRangeWarning: true });
            return;
        }

        const page = search ? (search.PageNumber || 1) : 1;
        // Cancela el trabajo y consumo de red de la búsqueda anterior antes de iniciar otra.
        if (this.searchController) this.searchController.abort();
        this.searchController = new AbortController();
        const requestId = ++this.searchRequest;
        enableSpinner(true);
        this.setState((state) => ({
            loading: true,
            tableVersion: page === 1 ? state.tableVersion + 1 : state.tableVersion,
            // Las búsquedas explícitas limpian el lote; navegar de regreso a página 1 lo conserva.
            selectedSessionIds: typeof search === 'number' ? [] : state.selectedSessionIds,
        }));
        try {
            // Este es el contrato exacto esperado por POST /pendingCutsByBranch.
            const data = {
                CodeBranchOffice: selectBranch,
                initialDate,
                finalDate,
                userSearch: userSearch || '',
                page,
                allowExtendedRange: isExtendedRange && extendedRangeApproved,
            };
            const response = await apiClient.getPendingCutsByBranch(data, this.searchController.signal);
            // Ignora una respuesta que perdió la carrera contra una búsqueda más reciente.
            if (requestId !== this.searchRequest) return;
            if (response.status !== SERVICE_RESPONSE.SUCCESS) {
                this.setState({ cuts: [], total: 0, gas: 0, comercio: 0, morePages: false, page: 1 });
                showAlert({ type: "error", message: response.message });
                return;
            }
            // Normaliza campos opcionales para que el render no dependa de valores nulos.
            const payload = response.data || {};
            const list = Array.isArray(payload.list) ? payload.list : [];
            this.setState({
                cuts: list,
                total: payload.total || 0,
                gas: payload.gas || 0,
                comercio: payload.comercio || 0,
                morePages: !!payload.morePages,
                page,
            });
        } catch (error) {
            // Las solicitudes canceladas o fallidas no alteran el resultado de una búsqueda vigente.
            if (requestId === this.searchRequest) {
                showAlert({ type: "error", message: "No fue posible consultar los cortes pendientes." });
            }
        } finally {
            if (requestId === this.searchRequest && !this.isUnmounted) {
                enableSpinner(false);
                this.setState({ loading: false });
            }
        }
    };

    // Restaura el rango seguro de bajo costo y ejecuta la consulta resultante.
    ClearFilters = () => {
        const today = moment().format('YYYY-MM-DD');
        this.setState({
            initialDate: today,
            finalDate: today,
            datesModified: true,
            userSearch: '',
            selectBranch: '',
            page: 1,
            extendedRangeApproved: false,
            showExtendedRangeWarning: false,
        }, () => this.SearchPendingCuts(1));
    };

    // Esta aprobación local también se envía al backend, que aplica la misma regla.
    ConfirmExtendedRange = () => {
        this.setState({
            extendedRangeApproved: true,
            showExtendedRangeWarning: false,
        }, () => this.SearchPendingCuts(1));
    };

    // Cancelar solo cierra el aviso; conserva las fechas elegidas para que puedan editarse.
    CancelExtendedRange = () => {
        this.setState({ showExtendedRangeWarning: false });
    };

    // Guarda el id para la API y los datos de fila para el encabezado del modal.
    OpenDetail = (session) => {
        this.setState({ idSessionSelected: session.idSession, sessionInfo: session });
    };

    // Desmonta el modal tras cerrarlo con Bootstrap para descartar su estado de facturas.
    OnCloseDetail = () => {
        this.setState({ idSessionSelected: null, sessionInfo: null });
    };

    ToggleCutSelection = (idSession) => {
        const sessionId = Number(idSession);
        this.setState((state) => {
            const selectedSessionIds = state.selectedSessionIds.includes(sessionId)
                ? state.selectedSessionIds.filter((id) => id !== sessionId)
                : [...state.selectedSessionIds, sessionId];
            return { selectedSessionIds };
        });
    };

    ToggleAllCuts = (selected) => {
        const pageIds = this.state.cuts.map((cut) => Number(cut.idSession));
        this.setState((state) => ({
            selectedSessionIds: selected
                ? Array.from(new Set([...state.selectedSessionIds, ...pageIds]))
                : state.selectedSessionIds.filter((id) => !pageIds.includes(id)),
        }));
    };

    ReprocessSelectedCuts = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { selectedSessionIds, processingCuts } = this.state;
        if (!selectedSessionIds.length || processingCuts) return;

        this.setState({ processingCuts: true });
        enableSpinner(true);
        try {
            const results = [];
            // Una llamada por sesión y en serie: processPayments modifica pagos en SAP.
            for (const idSession of selectedSessionIds) {
                try {
                    const result = await processPendingPayment('SESSION', { idSession });
                    results.push({ idSession, ...result });
                } catch (error) {
                    results.push({ idSession, processed: false, successPayments: [], errorsPays: [], message: error.message });
                }
            }

            const successful = results.filter((result) => result.processed);
            const failed = results.filter((result) => !result.processed);
            const paymentsProcessed = results.reduce((count, result) => count + result.successPayments.length, 0);
            const paymentErrors = results.reduce((count, result) => count + result.errorsPays.length, 0);
            // Mantiene la selección de sesiones con errores o resultados sin confirmación.
            if (!this.isUnmounted) {
                this.setState((state) => ({
                    selectedSessionIds: state.selectedSessionIds.filter((id) => !successful.some((result) => result.idSession === id)),
                }));
                await this.SearchPendingCuts({ PageNumber: this.state.page });
            }
            const firstError = failed[0];
            const errorDetail = firstError?.errorsPays?.[0]?.resp;
            showAlert({
                type: failed.length ? "error" : "success",
                message: `${paymentsProcessed} pago(s) reportado(s) como procesado(s); ${failed.length} sesión(es) con errores o sin confirmación` +
                    `${paymentErrors ? ` (${paymentErrors} error(es) de pago)` : ''}.` +
                    (firstError ? ` Sesión ${firstError.idSession}: ${typeof errorDetail === 'string' ? errorDetail : firstError.message}` : ''),
            });
        } finally {
            if (!this.isUnmounted) this.setState({ processingCuts: false });
            enableSpinner(false);
        }
    };

    // Los contadores de HANA pueden llegar como cadenas numéricas.
    formatCount = (n) => {
        return Number(n) || 0;
    };

    render() {
        const {
            _user, branches, selectBranch, initialDate, finalDate, userSearch,
            cuts, total, searchData, idSessionSelected, sessionInfo, loading, tableVersion,
            showExtendedRangeWarning, selectedSessionIds, processingCuts
        } = this.state;
        // react-select espera { value, label }; conserva el código de sucursal para la solicitud.
        const branchOptions = (branches || []).map((b) => ({ value: b.Code, label: b.Name }));
        const branchValue = branchOptions.find((o) => String(o.value) === String(selectBranch)) || null;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'CORTES PENDIENTES'} url1={'#'} />

                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="pendingCuts" className="text-muted">
                            &nbsp;CORTES PENDIENTES
                        </a>
                    </h2>

                    <div className="row mb-3 align-items-end">
                        <div className="col-12 col-md-5 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Sucursal:</strong></span>
                                </div>
                                <Select
                                    styles={sucursalSelectStyles}
                                    options={branchOptions}
                                    value={branchValue}
                                    isSearchable
                                    isClearable
                                    placeholder="Selecciona sucursal"
                                    noOptionsMessage={() => 'Sin sucursales'}
                                    onChange={this.ChangeBranch}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Desde:</strong></span>
                                </div>
                                <input
                                    type="date"
                                    className="form-control listSerie"
                                    value={initialDate}
                                    onChange={this.ChangeInitialDate}
                                    max='9999-12-31'
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Hasta:</strong></span>
                                </div>
                                <input
                                    type="date"
                                    className="form-control listSerie"
                                    value={finalDate}
                                    onChange={this.ChangeFinalDate}
                                    max='9999-12-31'
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-2">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text"><strong>Usuario:</strong></span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Código o nombre"
                                    value={userSearch}
                                    onChange={this.ChangeUserToSearch}
                                />
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3 mb-2">
                            <button className="btn btn-active mr-2" onClick={() => this.SearchPendingCuts(1)} disabled={loading}>
                                <i className="fa fa-search mr-1" aria-hidden="true" /> Buscar
                            </button>
                            <button className="btn btn-secondary" onClick={this.ClearFilters}>
                                <i className="fa fa-filter mr-1" aria-hidden="true" /> Limpiar
                            </button>
                        </div>
                        <div className="col-12 col-lg-4 mb-2 text-right">
                            <span title="Cortes con al menos una factura problemática">
                                Cortes con facturas problemáticas: {this.formatCount(total)}
                            </span>
                        </div>
                    </div>

                    <div className="row p-1">
                        <div className="col-xl-12 mb-4 mb-xl-0 responsive-row">
                            {/* DataTables solo aporta tabla y paginación; los filtros pertenecen a esta vista. */}
                            <DataTables
                                key={`pending-cuts-${tableVersion}`}
                                headers={headersDataTable}
                                view={"pendingCuts"}
                                data={cuts}
                                search={this.SearchPendingCuts}
                                openDetails={this.OpenDetail}
                                pendingCutsSelection={{
                                    selectedIds: selectedSessionIds,
                                    selectOne: this.ToggleCutSelection,
                                    selectAll: this.ToggleAllCuts,
                                }}
                                pendingCutsActions={{
                                    selectedCount: processingCuts ? 0 : selectedSessionIds.length,
                                    reprocess: this.ReprocessSelectedCuts,
                                }}
                                searchData={searchData}
                                refreshSearch={this.refreshSearch}
                                totalRows={[{ TotalRows: total }]}
                            />
                        </div>
                    </div>
                </div>

                {/* Monta el detalle únicamente después de seleccionar una fila. */}
                {idSessionSelected && (
                    <PendingCutDetailModal idSession={idSessionSelected} sessionInfo={sessionInfo} onClose={this.OnCloseDetail} />
                )}

                {/* Esta confirmación evita consultas históricas costosas por accidente. */}
                {showExtendedRangeWarning && (
                    <div className="modal fade show d-block" role="dialog" aria-modal="true" aria-labelledby="extendedRangeWarningTitle">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="extendedRangeWarningTitle">Rango de fechas amplio</h5>
                                    <button type="button" className="close" aria-label="Cerrar" onClick={this.CancelExtendedRange}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    El rango seleccionado supera los 31 días. La consulta puede tardar más y afectar el rendimiento. ¿Deseas continuar?
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.CancelExtendedRange}>Cancelar</button>
                                    <button type="button" className="btn btn-active" onClick={this.ConfirmExtendedRange}>Continuar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

// La alerta y el spinner compartidos mantienen esta vista de clase consistente con la aplicación.
const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PendingCutsView);
